const PARTS = new Intl.DateTimeFormat('en-US', {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/** "Mon 28 Sep, 09:00" in the viewer's time zone - for runs and posts. */
export function formatWhen(date: Date | string): string {
  const parts = Object.fromEntries(
    PARTS.formatToParts(new Date(date)).map((part) => [part.type, part.value]),
  );
  return `${parts.weekday} ${parts.day} ${parts.month}, ${parts.hour}:${parts.minute}`;
}
